"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var end2end_1 = require("@hudled/end2end");
var Box_1 = __importDefault(require("@mui/material/Box"));
var Stack_1 = __importDefault(require("@mui/material/Stack"));
var pick_1 = __importDefault(require("lodash/pick"));
var react_1 = __importDefault(require("react"));
var react_redux_firebase_1 = require("react-redux-firebase");
var NavTabs_1 = __importDefault(require("atomicComponents/atoms/NavTabs/NavTabs"));
var Table_1 = __importDefault(require("atomicComponents/atoms/Table/Table"));
var hooks_1 = require("atomicComponents/organisms/SortableHeader/hooks");
var context_1 = __importDefault(require("components/Money/context"));
var LoadingContent_1 = __importDefault(require("components/Spinners/LoadingContent"));
var HudledHelmet_1 = __importDefault(require("containers/App/HudledHelmet"));
var FooterMaker_1 = __importDefault(require("containers/TableMaker/FooterMaker"));
var HeaderMaker_1 = __importDefault(require("containers/TableMaker/HeaderMaker"));
var BatchActions_1 = require("./BatchActions");
var constants_1 = require("./constants");
var RechargesSearchAndFilter_1 = __importDefault(require("./RechargesSearchAndFilter"));
var RechargesTableBody_1 = __importDefault(require("./RechargesTableBody"));
var tableConf_1 = require("./tableConf");
var utils_1 = require("./utils");
var MONEY_CONTEXT_VAL = { fixedDecimals: true };
var FILTER_KEY_TO_STATUS = {
    next: 'nextInvoice',
    invoiced: 'includedInInvoice',
};
var RECHARGE_INVOICES_TABS = __spreadArray([
    { label: 'Charges', href: '/recharges/charges/all' }
], __read(['new', 'excluded', 'next', 'invoiced', 'paid', 'failed'].map(function (slug) {
    var _a;
    return (__assign({ href: "/recharges/charges/".concat(slug), label: (0, end2end_1.kebabToProper)(slug) }, (0, pick_1.default)(constants_1.RECHARGER_STATUS_MAPPER[(_a = FILTER_KEY_TO_STATUS[slug]) !== null && _a !== void 0 ? _a : slug], ['icon', 'iconColor'])));
})), false);
var Header = react_1.default.memo((0, HeaderMaker_1.default)(tableConf_1.rechargesTableConf));
var Footer = react_1.default.memo((0, FooterMaker_1.default)(tableConf_1.rechargesTableConf));
var RechargesTable = function (_a) {
    var allRecharges = _a.allRecharges, filterKey = _a.filterKey, selectedIds = _a.selectedIds;
    var _b = __read(react_1.default.useState(new Date()), 2), landingTime = _b[0], setLandingTime = _b[1];
    react_1.default.useEffect(function () { return setLandingTime(new Date()); }, [filterKey]);
    var recharges = react_1.default.useMemo(function () { return filterKey === 'all'
        ? allRecharges === null || allRecharges === void 0 ? void 0 : allRecharges.filter(function (charge) { return !charge.excludedOn || charge.excludedOn.toDate() > landingTime; })
        : allRecharges && allRecharges.filter(function (inv) { var _a; return inv.rechargerStatus === ((_a = FILTER_KEY_TO_STATUS[filterKey]) !== null && _a !== void 0 ? _a : filterKey); }); }, [allRecharges, filterKey]);
    var _c = __read((0, utils_1.useFilterRecharges)(recharges !== null && recharges !== void 0 ? recharges : []), 3), filteredRecharges = _c[0], searchProps = _c[1], filterProps = _c[2];
    var sortedRecharges = (0, hooks_1.useSortArray)(filteredRecharges, tableConf_1.rechargesTableConf.extractors);
    if (!(0, react_redux_firebase_1.isLoaded)(sortedRecharges) || !(0, react_redux_firebase_1.isLoaded)(filteredRecharges)) {
        return (0, jsx_runtime_1.jsx)(LoadingContent_1.default, {});
    }
    return ((0, jsx_runtime_1.jsxs)(context_1.default.Provider, __assign({ value: MONEY_CONTEXT_VAL }, { children: [(0, jsx_runtime_1.jsx)(HudledHelmet_1.default, { title: "Recharges - Charges", description: "Recharges - Charges" }), (0, jsx_runtime_1.jsx)(Box_1.default, __assign({ pl: 2 }, { children: (0, jsx_runtime_1.jsx)(NavTabs_1.default, { tabs: RECHARGE_INVOICES_TABS }) })), (0, jsx_runtime_1.jsx)(Stack_1.default, __assign({ ml: 4.5, pt: 3, pb: 1, height: 64, direction: "row", alignItems: "center" }, { children: !!selectedIds.length && (0, jsx_runtime_1.jsx)(BatchActions_1.BatchActions, {}) })), (0, jsx_runtime_1.jsx)(RechargesSearchAndFilter_1.default, __assign({ recharges: recharges !== null && recharges !== void 0 ? recharges : [], filteredRecharges: filteredRecharges }, searchProps, { selectedFilters: filterProps.selectedFilters, setSelectedFilters: filterProps.setSelectedFilters })), (0, jsx_runtime_1.jsxs)(Table_1.default, __assign({ sizing: "compact" }, { children: [(0, jsx_runtime_1.jsx)(Header, { width: "fit-content", count: sortedRecharges.length }), (0, jsx_runtime_1.jsx)(RechargesTableBody_1.default, { sortedRecharges: sortedRecharges, filterKey: filterKey }), (0, jsx_runtime_1.jsx)(Footer, { items: filteredRecharges !== null && filteredRecharges !== void 0 ? filteredRecharges : [], width: "fit-content" })] }))] })));
};
exports.default = react_1.default.memo(RechargesTable);
